export default {
  "content": "<path d=\"M496 16L15.88 208 195 289 448 64 223 317l81 179L496 16z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "class": "ionicon",
    "viewBox": "0 0 512 512"
  }
};